import * as yup from 'yup'
import { useFormik } from 'formik'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

export const useLoginController = ({ adminLoginThunk }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [otp, setOtp] = useState('')
  const [otpRequired, setOtpRequired] = useState(false)

  const loginSchema = yup.object({
    email: yup
      .string()
      .label(t('email'))
      .email(t('invalidEmailFormat'))
      .required((props) => t('isRequired', props)),
    password: yup
      .string()
      .label(t('password'))
      .min(4, (props) => t('mustbeAtleast4Characters', { ...props, minNumber: 4 }))
      .max(32, (props) => t('cannotExceed32Characters', { ...props, maxNumber: 32 }))
      .required((props) => t('isRequired', props))
  })

  const { handleSubmit, values, handleChange, errors } = useFormik({
    initialValues: {
      email: '',
      password: ''
    },
    validationSchema: loginSchema,
    onSubmit: async ({ email, password }) => {
      adminLoginThunk({
        token: Number(otp),
        email,
        password,
        setOtpRequired,
        navigate
      })
    }
  })

  return {
    otpRequired,
    otp,
    setOtp,
    handleSubmit,
    values,
    handleChange,
    errors,
    t
  }
}
